// extracted by mini-css-extract-plugin
export default {"item":"days-stats_item__7MDNS"};